import { Component, HostListener, OnInit } from '@angular/core';
import { filter } from 'rxjs/operators';

import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, AuthenticationResult, InteractionStatus } from '@azure/msal-browser';
import { createClaimsTable } from '@app/utils/claim-utils';
import { AlertService } from '@app/modules/alert';
import { AzureUser } from '@app-models/azure-user'
import { getCurrentUserFromStorage } from "@app/utils/storage-utils";
import { GlobalService } from '@app/services/global.services';
import { environment } from 'environments/environment';
import { OrgDataService } from '@app/services/org-data.service';
import { SoModalService } from '@app/shared';
import { GlobalConstants } from '@app/utils/global-constants';


@Component({
    selector: 'so-user-profiles',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
    constructor(private authService: MsalService,
        public alertService: AlertService,
        private globalservices: GlobalService,
        private orgDataService: OrgDataService,
        protected soModalService: SoModalService,
        private msalBroadcastService: MsalBroadcastService) { }

    systemDate = this.globalservices.getSystemDate();
    globalConstants = GlobalConstants;
    testMode = environment.showTestItems;
    appToken = null;
    loginDisplay = false;
    currentUser: AzureUser;
    displayedColumns: string[] = ['claim', 'value', 'description'];
    dataSource: any = [];
    options = {
        autoClose: false,
        keepAfterRouteChange: false
    };
    public getScreenWidth: any;
    public getScreenHeight: any;


    ngOnInit(): void {
        this.getScreenWidth = window.innerWidth;
        this.getScreenHeight = window.innerHeight;
        this.currentUser = getCurrentUserFromStorage();
        this.getApplicationAccessToken();
        this.msalBroadcastService.msalSubject$
            .pipe(
                filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
            )
            .subscribe((result: EventMessage) => {
                const payload = result.payload as AuthenticationResult;
                this.authService.instance.setActiveAccount(payload.account);

            });

        this.msalBroadcastService.inProgress$
            .pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None)
            )
            .subscribe(() => {
                this.setLoginDisplay();

                this.getClaims(this.authService.instance.getActiveAccount()?.idTokenClaims);

            })

        /*
        this.orgDataService.getDepartments().subscribe({
            next: (entries: any) => {
                console.log(entries);
            }
        });
        */

    }

    @HostListener('window:resize', ['$event'])

    onWindowResize() {
        this.getScreenWidth = window.innerWidth;
        this.getScreenHeight = window.innerHeight;
    }
    //this loop through local storage looking for entry that is an access token with a scope of the api
    //605b87ad-91df-4617-9a13-d20522a8344a.cddc1229-ac2a-4b97-b78a-0e5cacb5865c-login.windows.net-accesstoken-b81e9f6e-f665-4173-8a4a-88b2e5b16cb1-cddc1229-ac2a-4b97-b78a-0e5cacb5865c-api://b81e9f6e-f665-4173-8a4a-88b2e5b16cb1/user_impersonation--
    getApplicationAccessToken() {
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i) || '';
            if (key.indexOf('access') > -1 && key.indexOf('api') > -1) {
                const x = JSON.parse(localStorage.getItem(key) || '');
                this.appToken = x['secret'];
            }
        }
    }
    /**
     * this is to control content in the home page based on if the user is logged in or not.
     */
    setLoginDisplay() {
        this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;


    }



    getClaims(claims: any) {
        if (claims) {
            const claimsTable = createClaimsTable(claims);
            this.dataSource = [...claimsTable];
        }
    }
}
